var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 11.6667V15H11.6667V11.6667H28.3333ZM25 18.3333V21.6667H11.6667V18.3333H25ZM30 33.3333L35 36.6667V5H5V36.6667L10 33.3333L15 36.6667L20 33.3333L25 36.6667L30 33.3333ZM31.6667 8.33333V30.4333L30 29.3333L25 32.6667L20 29.3333L15 32.6667L10 29.3333L8.33333 30.4333V8.33333H31.6667Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon);
export default __webpack_public_path__ + "static/media/invoices_icon.4f1a5b40595089b7c688d849f139f9bc.svg";
export { ForwardRef as ReactComponent };